import * as React from 'react';

import styles from './LeftRight.module.css';

type Props = {
  children: React.ReactNode;
};

function LeftRight({ children }: Props): JSX.Element {
  return <div className={styles.container}>{children}</div>;
}

export default LeftRight;
